import React, { Component } from 'react';
import Header from './Header';
import DisplayPokemon from './DisplayPokemon';
import PokeDetail from './PokeDetail';
import AdoptPokemon from './AdoptPokemon';
import ListOfGuardians from './ListOfGuardians';
import Footer from './Footer';
import '../styles/App.scss';

class App extends Component {
  constructor(props) {
    super(props);
      this.state = {
        selectedPokemon: '',
        adoptPokemon: '',
        offset: 0,
        limit: 8,
      }
  }
  //Get and set the name of the selected pokemon
  selectedPokemonDetails = (pokeId) => {
    this.setState({
      selectedPokemon: pokeId,
    }) 
  }
  //Get and set the adopted pokemon 
  userAdoptedPokemon = (pokemonName) => {
    this.setState({
      adoptPokemon: pokemonName,
    })
  }
  //Set state of the offset value and increments it by 8 when next page button is clicked
  handleNextPage = () => {
    this.setState({
      offset: this.state.offset + 8,
    })
  }
  //Set state of the offset value decrements by 8 when previous page button is clicked
  handlePrevPage = () => {
    this.setState({
      offset: this.state.offset - 8,
    })
  }

    render() {
      return(
        <div>
          <Header />

          <DisplayPokemon
            selectedPokemonDetails = {this.selectedPokemonDetails}
            adoptedPokemon = {this.userAdoptedPokemon}
            offset = {this.state.offset}
            limit = {this.state.limit}
          />
          <div className="buttonContainer wrapper">
            <button className="button" onClick={this.handlePrevPage}>Prev</button>
            <button className="button" onClick={this.handleNextPage}>Next</button>
          </div>

        <PokeDetail 
          selectedPokemon = {this.state.selectedPokemon}
        />

        <AdoptPokemon 
          adoptedPokemon = {this.state.adoptPokemon}
          selectedPokemonDetails={this.selectedPokemonDetails}
        />

        <ListOfGuardians />

        <Footer />
      </div>
    )
  }
}
export default App;
